import React from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router'
import { Box } from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import Tab from '@mui/material/Tab'
import { useTranslation } from 'react-i18next'

const EventLayout: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const tabs = [
    {
      value: '/events',
      label: t('EventLayout.MyEvents.Tab', 'My Events'),
      path: '/events',
    },
    {
      value: '/events/leadership-training',
      label: t(
        'EventLayout.LeadershipTraining.Tab',
        'Leadership Training\nRegistration'
      ),
      path: '/events/leadership-training',
    },
  ]

  const isLeadershipRoute = location.pathname.startsWith(
    '/events/leadership-training'
  )
  const isEventDetailsRoute = location.pathname.startsWith(
    '/events/event-details'
  )

  const currentTab = isLeadershipRoute ? tabs[1].value : tabs[0].value

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    navigate(newValue, { replace: true })
  }

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={currentTab}>
        {!isEventDetailsRoute && (
          <TabList
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                sx={{ whiteSpace: 'pre-line' }}
              />
            ))}
          </TabList>
        )}

        <Box sx={{ mt: isEventDetailsRoute ? 0 : 2 }}>
          <Outlet />
        </Box>
      </TabContext>
    </Box>
  )
}

export default EventLayout
